import { render, staticRenderFns } from "./ProjectVersionPreviewCreate.vue?vue&type=template&id=c9048812&lang=pug&"
import script from "./ProjectVersionPreviewCreate.vue?vue&type=script&lang=js&"
export * from "./ProjectVersionPreviewCreate.vue?vue&type=script&lang=js&"
import style0 from "./ProjectVersionPreviewCreate.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports